import { stringify } from 'query-string';
import {
  CrudDetailsRequestModel,
  CrudListRequestModel,
  CrudRequestModel,
} from '../models';
import * as http from './http';
import ApiService from './service';
import { Dict } from '../../models';

export default class CrudService extends ApiService {
  public async getList<T = any>(
    request: CrudListRequestModel
  ): Promise<{ data: T[]; count: number }> {
    const query: Dict = {
      ...request.queryParams,
    };

    for (const key in query) {
      if (query[key]) {
        query[key] =
          query[key] instanceof Date
            ? query[key].toISOString()
            : query[key]?.toString();
      }
    }

    if (request.filters) {
      query._filters = JSON.stringify(request.filters);
    }

    if (request.pagination) {
      const { page = 1, perPage = 10 } = request.pagination;
      query._start = page * perPage;
      query._end = query._start + perPage;
    }

    if (request.sort) {
      const { field, order } = request.sort;
      query._sort = field;
      query._order = order;
    }

    const url = `${this.apiDomain}/${request.resource}?${stringify(query)}`;

    const response = await http.get<T[]>(url, this.token);
    return { data: response.data, count: response.headers['x-total-count'] };
  }

  public async create<T = any, U = T>(
    request: CrudRequestModel,
    data: T
  ): Promise<U> {
    const url = `${this.apiDomain}/${request.resource}`;
    const response = await http.post<T, U>(url, data, this.token);
    return response.data;
  }

  public async get<T = any>(request: CrudDetailsRequestModel): Promise<T> {
    const url = `${this.apiDomain}/${request.resource}/${request.resourceId}`;
    const response = await http.get<T>(url, this.token);
    return response.data;
  }

  public async update<T = any>(
    request: CrudDetailsRequestModel,
    data: Partial<T>
  ): Promise<T> {
    const url = `${this.apiDomain}/${request.resource}/${request.resourceId}`;
    const response = await http.put<Partial<T>, T>(url, data, this.token);
    return response.data;
  }

  public async remove<T = any>(
    request: CrudDetailsRequestModel
  ): Promise<T | undefined> {
    const url = `${this.apiDomain}/${request.resource}/${request.resourceId}`;
    const response = await http.remove<T | undefined>(url, this.token);
    return response.data;
  }
}
